function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1663",
  "data-name": "Group 1663",
  transform: "translate(-1397 -88)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_21",
  "data-name": "Ellipse 21",
  transform: "translate(1397 88)",
  fill: "#f5f5f5",
  stroke: "#333",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "none"
})), /*#__PURE__*/React.createElement("text", {
  id: "_",
  "data-name": "?",
  transform: "translate(1405 106)",
  fill: "#333",
  fontSize: 16,
  fontFamily: "Poppins-Bold, Poppins",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "?")));

var SvgSupport = function SvgSupport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSupport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/support.293ee53f.svg";
export { ForwardRef as ReactComponent };